import React from 'react'
import styled from 'styled-components'
import MainLogo from 'atoms/MainLogo'
import MainNavItems from 'molecules/MainNavItems'
import { media } from 'tools/browser'
import { ThemeConsumer } from 'contexts/theme-context'
import { ConfigConsumer } from 'contexts/config-context'
import MainNavRight from './components/MainNavRight'

const Wrapper = styled.header`
  height: 89px;
  display: flex;
  padding: 0 24px;
  border-bottom: 1px solid rgba(226, 226, 226, 0.5);
  justify-content: center;
  font-size: 16px;

  ${media.greaterThan.large`
      font-size: 14px;
  `}

  ${media.greaterThan.extraLarge`
    font-size: 16px;
  `}
`

const MainNavLeft = styled.div`
  margin-right: auto;
  display: flex;
  align-items: center;
`

const ContentWrapper = styled.div`
  display: flex;
  align-content: center;
  width: ${(props) => props.width || '1280px'};
`

function MainNav(props) {
  return (
    <ThemeConsumer>
      {(theme) => (
        <ConfigConsumer>
          {(config) => (
            <Wrapper>
              <ContentWrapper width={config.contentMaxWidth}>
                <MainNavLeft>
                  <MainLogo wordmark={theme.wordmark} />
                  <MainNavItems />
                </MainNavLeft>
                <MainNavRight suppressAuthUI={config.suppressAuthUI} />
              </ContentWrapper>
            </Wrapper>
          )}
        </ConfigConsumer>
      )}
    </ThemeConsumer>
  )
}

export default MainNav



// WEBPACK FOOTER //
// ./src/organisms/Header/DesktopHeader/components/MainNav/MainNav.js